<template>
  <div class="content" v-if="giftLive !== {}">
    <div class="publish-time" v-show="giftLive.ddatetime">
      <!--      <i class="el-icon-time"></i>-->
      <!--      数据时间：{{ $moment(giftLive.ddatetime).format('YYYY-MM-DD HH:mm') }}-->
      <div>
        {{ $moment(giftLive.ddatetime).format("YYYY-MM-DD HH:mm") }}更新
      </div>
    </div>
    <div class="tab-header">
      <div class="left">
        <img src="@/assets/images/address.png" alt="" />
        <div>{{ name }}</div>
      </div>
      <div class="temp" v-show="giftLive.t">
        {{ giftLive.t === -999.9 ? "--" : giftLive.t.toFixed(1) }} <span class="c">℃</span>
      </div>
    </div>
    <div class="element">
      <div class="element-item small">
        <div class="left">
          <img src="@/assets/images/风速.png" />
          <span>风速</span>
        </div>
        <span class="value">
          {{ giftLive.wd2df === -999.9 ? "--" : giftLive.wd2df.toFixed(1) }} m/s({{
            giftLive.wd2df === -999.9
              ? "--"
              : getWindforce(Number(giftLive.wd2df))
          }}级)</span>
      </div>
      <div class="element-item small">
        <div class="left">
          <img src="@/assets/images/风向.png" />
          <span>风向</span>
        </div>
        <span class="value"> {{ giftLive.winddName }}</span>
      </div>
      <template v-if="labelid == 4">
        <div class="element-item small">
          <div class="left">
            <img src="@/assets/images/湿度_sk_icon.png" />
            <span>湿度</span>
          </div>
          <span class="value">{{ giftLive.rh }} %</span>
        </div>
        <div class="element-item small">
          <div class="left">
            <img src="@/assets/images/气压_sk_icon.png" />
            <span>气压</span>
          </div>
          <span class="value">{{ giftLive.p.toFixed(1) }} hPa</span>
        </div>
      </template>
      <template v-else>
        <div class="element-item small" @click="handleShowUltravioletRays()">
          <div class="left">
            <img src="@/assets/images/紫外线_icon.png" />
            <span>紫外线</span>
          </div>
          <span class="value" v-if="
            ultravioletRaysResultData &&
            ultravioletRaysResultData.uvis &&
            ultravioletRaysResultData.uvis.length > 0
          ">
            {{
              ultravioletRaysResultData.uvis[
              ultravioletRaysResultData.uvis.length - 1
              ]
            }}
            μW/cm²</span>
        </div>
        <div class="element-item small">
          <div class="left">
            <img src="@/assets/images/光照强度.png" />
            <span>光照强度</span>
          </div>
          <span class="value">{{ lightIntensity }} lux</span>
        </div>
      </template>
      <div class="element-item">
        <div class="item">
          <div class="left">
            <!--          <img src="@/assets/images/过去1小时雨量.png" />-->
            <span>1小时雨量</span>
          </div>
          <span class="value">{{ giftLive.r01h === -999.9 ? "--" : giftLive.r01h }} mm</span>
        </div>
        <div class="item">
          <div class="left">
            <!--          <img src="@/assets/images/过去1小时雨量.png" />-->
            <span>3小时雨量</span>
          </div>
          <span class="value">{{ giftLive.r03h === -999.9 ? "--" : giftLive.r03h }} mm</span>
        </div>
        <div class="item">
          <div class="left">
            <!--          <img src="@/assets/images/过去1小时雨量.png" />-->
            <span>6小时雨量</span>
          </div>
          <span class="value">{{ giftLive.r06h === -999.9 ? "--" : giftLive.r06h }} mm</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { findWind, getWindforce } from "@/utils/tool.js";

export default {
  props: ["params"],
  name: "multi-wearher-wqsk",
  data() {
    return {
      giftLive: {},
      name: "",
      ultravioletRaysResultData: {},
      unitZjStationDataResultData: [],
      labelid: "",
    };
  },
  watch: {
    activeCountyId: {
      handler() {
        setTimeout(() => {
          const item = this.objsList.find(
            (item) => item.id === this.activeCountyId,
          );
          this.name = item.name;
          this.getGiftLive();
        }, 100);
      },
    },
    tqskDateResult: {
      handler() {
        setTimeout(() => {
          this.getGiftLive();
        }, 100);
      },
      deep: true,
    },
    ultravioletRaysResult: {
      handler() {
        this.$nextTick(() => {
          this.getUltravioletRaysResult();
        });
      },
      deep: true,
    },
    unitZjStationDataResult: {
      handler() {
        this.$nextTick(() => {
          this.getUnitZjStationDataResult();
        });
      },
      deep: true,
    },
  },
  created() {
    this.getUnitLabelId();
  },
  mounted() {
    setTimeout(() => {
      const item = this.objsList.find(
        (item) => item.id === this.activeCountyId,
      );
      this.name = item.name;
      this.getGiftLive();
    }, 100);
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "cartData",
      "tqskDateResult",
      "ultravioletRaysResult",
      "unitZjStationDataResult",
    ]),
    lightIntensity() {
      const data = this.unitZjStationDataResultData;
      if (!data || data.length === 0) {
        return "---";
      }
      const point = data[0];
      if (!point) {
        return "---";
      }
      return point.light;
    },
  },
  methods: {
    getWindforce,

    ...mapMutations("home", ["changeCartItem"]),
    /**
     * 实况数据
     */
    getUnitLabelId() {
      const company = this.$route.params.company;
      const { unit } = JSON.parse(localStorage.getItem(company));
      this.labelid = unit.labelid;
    },
    async getGiftLive() {
      this.giftLive = this.tqskDateResult;
      console.log("tqskDateResult", this.tqskDateResult);
      this.giftLive.winddName =
        this.giftLive.wd2dd === -999.9 ? "--" : findWind(this.giftLive.wd2dd);
    },
    handleShowUltravioletRays() {
      this.$bus.$emit("showUltravioletRays", true);
    },
    getUltravioletRaysResult() {
      this.ultravioletRaysResultData = this.ultravioletRaysResult;
    },
    getUnitZjStationDataResult() {
      this.unitZjStationDataResultData = this.unitZjStationDataResult;
      console.log(
        "unitZjStationDataResultData",
        this.unitZjStationDataResultData,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 1.2rem;
  //position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  //padding: 3.3vw 1.04vw 1.3vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  //height: 100%;
  border-radius: 0.63vw;
  //pointer-events: none;
  // background: url('../../../assets/images/天气实况背景.png') no-repeat;
  // background-size: 100%;

  .tab-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    //margin-bottom: 0.52vw;
    //margin: 0.3vw 0;
    margin-bottom: 0.3vw;
    font-size: 0.83vw;
    color: #ffffff;

    .left {
      display: flex;
      align-items: flex-end;

      img {
        width: 0.83vw;
        height: 0.93vw;
        margin-right: 0.42vw;
      }
    }

    .temp {
      display: flex;
      align-items: self-start;
      font-size: 2.2vw;
      //line-height: 0px;
      font-weight: 600;
      text-align: center;

      span {
        font-weight: 320;
        position: relative;
        top: -0.22vw;
        margin-left: 0.26vw;
        font-size: 1.35vw;
      }
    }
  }

  .element {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-radius: 0.31rem;

    .element-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 0.78vw 0 0.47vw;
      width: 100%;
      // height: 9vh;
      height: 26px;

      background: linear-gradient(135deg,
          rgba(106, 152, 199, 0.4) 0%,
          rgba(87, 86, 141, 0.4) 51%,
          rgba(60, 108, 112, 0.4) 100%);
      border-radius: 5px;
      // opacity: 0.4;
      border: 2px solid;
      border-image: linear-gradient(135deg,
          rgba(112, 176, 247, 0.4),
          rgba(78, 133, 211, 0),
          rgba(112, 178, 250, 0.4)) 2 2;

      .item {
        display: flex;

        .left {
          display: flex;
          align-items: center;
          margin-right: 0.5rem;
        }
      }

      .left {
        display: flex;
        align-items: center;
      }

      img {
        width: 0.94vw;
        margin-right: 0.36vw;
      }

      span {
        font-size: 0.73vw;
        color: #fff;
      }

      .value {
        font-weight: 600;
        color: #b6e6fd;
      }
    }

    //.element-item:nth-child(1),
    //.element-item:nth-child(2) {
    //  width: calc((100% - 0.57vw) / 2);
    //  margin-bottom: 0.52vw;
    //}
    //
    //.element-item:nth-child(3),
    //.element-item:nth-child(4) {
    //  width: calc((100% - 0.57vw) / 2);
    //  margin-bottom: 0.52vw;
    //}
  }

  .small {
    width: calc((100% - 0.57vw) / 2) !important;
    margin-bottom: 0.52vw;
  }

  // .element-item:nth-child(2) {
  //   margin: 0vw 0.52vw;
  // }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: 0.8vw;
    color: #fff;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}

// }
</style>
